import { C as CurrencyCode, b as CURRENCY_SYMBOLS } from '../currency-_kacFJHO.js';

const getCurrencySign = (currencyCode) => CURRENCY_SYMBOLS[currencyCode];
const isValidCurrencyCode = (value) => Object.values(CurrencyCode).includes(value);
const CURRENCY_MAPPING = {
    FR: CurrencyCode.EUR,
    CH: CurrencyCode.CHF,
    EU: CurrencyCode.EUR,
    LI: CurrencyCode.CHF,
    UK: CurrencyCode.GBP,
    GB: CurrencyCode.GBP,
    PL: CurrencyCode.PLN,
    AE: CurrencyCode.AED,
    RO: CurrencyCode.RON,
};
const getCurrencyCode = (locality) => {
    const localityCode = locality === null || locality === void 0 ? void 0 : locality.toUpperCase();
    return Object.hasOwn(CURRENCY_MAPPING, localityCode)
        ? CURRENCY_MAPPING[localityCode]
        : CURRENCY_MAPPING.EU;
};
var currency = {};

export { currency as default, getCurrencyCode, getCurrencySign, isValidCurrencyCode };
//# sourceMappingURL=currency.js.map
